import { PersonnelsStore } from "@/services/stores/types";

export const selectPersonnelsStore = ({
  personnels,
  setPersonnels,
  resetPersonnels,
  selectedPersonnelMode,
  setSelectedPersonnelMode,
}: PersonnelsStore) => ({
  personnels,
  setPersonnels,
  resetPersonnels,
  selectedPersonnelMode,
  setSelectedPersonnelMode,
});

export const selectPersonelsData = ({ personnels }: PersonnelsStore) => ({
  personnels,
});
